import {createReducer, createSlice, combineReducers} from "@reduxjs/toolkit";
import {createAction} from 'redux-actions';

export const setManagedEvent = createAction("SET_MANAGED_EVENT");
export const setSavedImageHotspotConfigs = createAction("SET_SAVED_IMAGE_HOTSPOT_CONFIGS");
export const addImageHotspotConfig = createAction("ADD_IMAGE_HOTSPOT_CONFIG");
export const abortNewImageHotspotConfigs = createAction("ABORT_NEW_IMAGE_HOTSPOT_CONFIGS")
export const updateImageHotspotConfig = createAction("UPDATE_IMAGE_HOTSPOT_CONFIG")
export const setCurrentImageHotspotId = createAction("SET_CURRENT_IMAGE_HOTSPOT_ID")
export const removeImageHotspot = createAction("REMOVE_IMAGE_HOTSPOT")

export const appendSupportChatMessage = createAction("APPEND_SUPPORT_CHAT_MESSAGE")
export const appendSupportChatSession = createAction("APPEND_SUPPORT_CHAT_SESSION")
export const setSupportChatSessionId = createAction("SET_SUPPORT_CHAT_SESSION_ID")


const reducer = createReducer({}, {
  // ["CABLE_EVENT_UPDATED"]: (state, action) => {
  //   if(action.event.id in state.events)
  //     state.events[action.event.id] = action.event

  //   if(action.event.id == state.videoRoom.event.id)
  //     state.videoRoom.event = action.event
  // },
  // ["CABLE_EVENT_QUESTION_UPDATED"]: (state, action) => {
  //   if(action.data.event_id in state.events)
  //     state.events[action.data.event_id].questions[state.events[action.data.event_id].questions.findIndex((question) => question.id == action.data.id)] = action.data
  // },
  // ["CABLE_VIDEO_ROOM_UPDATED"]: (state, action) => {
  //   if(action.payload.id == state.videoRoom.id)
  //     state.videoRoom = action.payload
  // },
  // ["CABLE_BET_UPDATED"]: (state, action) => {
  //   state.votings[action.payload.id] = action.payload
  // },
  // ["CABLE_BETTING_CREATED"]: (state, action) => {
  //   if(action.payload.tag_owner_id == state.tagOwner.id)
  //     state.bettings.push(action.payload)
  // },
  // ["CABLE_EVENT_QUESTION_CREATED"]: (state, action) => {
  //   if(action.data.event_id in state.events)
  //     state.events[action.data.event_id].questions.push(action.data)
  // },
  // ["CABLE_EVENT_QUESTION_DELETED"]: (state, action) => {
  //   if(action.data.event_id in state.events)
  //     state.events[action.data.event_id].questions.splice(state.events[action.data.event_id].questions.findIndex((question) => question.id == action.data.id),1)
  // },
  // ["CABLE_CHAT_MESSAGE_CREATED"]: (state, action) => {
  //   if(action.payload.event_id in state.events)
  //     state.chats[action.payload.event_id].push(action.payload)
  // },
  // ["CABLE_CHAT_MESSAGE_DESTROYED"]: (state, action) => {
  //   if(action.payload.event_id in state.events)
  //     state.chats[action.payload.event_id].splice(state.chats[action.payload.event_id].findIndex((chat) => chat.id == action.payload.id),1)
  // },
  // [setManagedEvent]: (state, action) => {
  //   console.warn("setManagedEvent")
  //   state.managedEventId = action.payload
  // },
  [removeImageHotspot]: (state, action) => {
    console.warn("removeImageHotspot", action)
    state.image_hotspot_configs = state.image_hotspot_configs.filter((ihc) => ihc.id.toString() != action.payload.toString())
  },
  [setSavedImageHotspotConfigs]: (state, action) => {
    state.persisted_image_hotspot_configs = action.payload
    state.image_hotspot_configs = action.payload
  },
  [updateImageHotspotConfig]: (state, action) => {
    state.image_hotspot_configs[state.image_hotspot_configs.findIndex(ihc => String(ihc.id) === String(action.payload.id))] = Object.assign({}, state.image_hotspot_configs[state.image_hotspot_configs.findIndex(ihc => String(ihc.id) === String(action.payload.id))], action.payload)
  },
  [addImageHotspotConfig]: (state, action) => {
    state.image_hotspot_configs.push(action.payload)
  },
  [abortNewImageHotspotConfigs]: (state, action) => {
    state.image_hotspot_configs = state.image_hotspot_configs.filter(image_hotspot_config => image_hotspot_config.id)
  },
  [setCurrentImageHotspotId]: (state, action) => {
    state.setCurrentImageHotspotId = action.payload
  },
  [appendSupportChatMessage]: (state, action) => {
    const supportChatSession = state.supportChatSessions.find((supportChatSession) => supportChatSession.id === action.payload.support_chat_session_id)
    if (supportChatSession) {
      // Just to be save so there are no duplicated messages.
      supportChatSession.support_chat_messages = supportChatSession.support_chat_messages.filter((supportChatMessage) => supportChatMessage.id !== action.payload.id)
      supportChatSession.support_chat_messages.push(action.payload)
    }
  },
  [appendSupportChatSession]: (state, action) => {
    // Just to be save so there are no duplicated sessions.
    state.supportChatSessions = state.supportChatSessions.filter((supportChatSession) => supportChatSession.id !== action.payload.id)
    state.supportChatSessions.push(action.payload)
  },

  [setSupportChatSessionId]: (state, action) => {
    state.supportChatSessionId = action.payload
  },

  ["CABLE_ACCOUNT_ORGANIZATION_UPDATED"]: (state, action) => {
    state.imageMaps = state.imageMaps.map(imageMap => {
      return {
        ...imageMap,
        account_organization: imageMap.account_organization_id === action.payload.id ? action.payload : imageMap.account_organization
      }
    })
  },

  ["CABLE_SUPPORT_CHAT_SESSION_CREATED"]: (state, action) => {
    if (state.tagOwner.id == action.payload.tag_owner_id) {
      state.supportChatSessions = state.supportChatSessions.filter((supportChatSession) => supportChatSession.id !== action.payload.id)
      state.supportChatSessions.push(action.payload)
    }
  },
  ["CABLE_SUPPORT_CHAT_SESSION_UPDATED"]: (state, action) => {
    if (state.tagOwner.id == action.payload.tag_owner_id) {
      state.supportChatSessions = state.supportChatSessions.filter((supportChatSession) => supportChatSession.id !== action.payload.id)
      state.supportChatSessions.push(action.payload)
    }
  },
  ["CABLE_SUPPORT_CHAT_SESSION_DESTROYED"]: (state, action) => {
    state.supportChatSessions = state.supportChatSessions.filter((supportChatSession) => supportChatSession.id !== action.payload.id)
  },

  ["CABLE_SUPPORT_CHAT_MESSAGE_CREATED"]: (state, action) => {
    const supportChatSession = state.supportChatSessions.find((supportChatSession) => supportChatSession.id === action.payload.support_chat_session_id)
    if (supportChatSession) {
      // Just to be save so there are no duplicated messages.
      supportChatSession.support_chat_messages = supportChatSession.support_chat_messages.filter((supportChatMessage) => supportChatMessage.id !== action.payload.id)
      supportChatSession.support_chat_messages.push(action.payload)
    }
  },
  ["CABLE_SUPPORT_CHAT_MESSAGE_UPDATED"]: (state, action) => {
    const supportChatSession = state.supportChatSessions.find((supportChatSession) => supportChatSession.id === action.payload.support_chat_session_id)
    if (supportChatSession) {
      // Just to be save so there are no duplicated messages.
      supportChatSession.support_chat_messages = supportChatSession.support_chat_messages.filter((supportChatMessage) => supportChatMessage.id !== action.payload.id)
      supportChatSession.support_chat_messages.push(action.payload)
    }
  },
  ["CABLE_SUPPORT_CHAT_MESSAGE_DESTROYED"]: (state, action) => {
    const supportChatSession = state.supportChatSessions.find((supportChatSession) => supportChatSession.id === action.payload.support_chat_session_id)
    if (supportChatSession) {
      supportChatSession.support_chat_messages = supportChatSession.support_chat_messages.filter((supportChatMessage) => supportChatMessage.id !== action.payload.id)
    }
  },

  ["CABLE_IMAGE_MAP_CONFIG_CREATED"]: (state, action) => {
    state.imageMapConfigs = [
      ...state.imageMapConfigs.filter((imageMapConfig) => imageMapConfig.id !== action.payload.id),
      action.payload
    ]
  },
  ["CABLE_IMAGE_MAP_CONFIG_UPDATED"]: (state, action) => {
    state.imageMapConfigs = [
      ...state.imageMapConfigs.filter((imageMapConfig) => imageMapConfig.id !== action.payload.id),
      action.payload
    ]
  },
  ["CABLE_IMAGE_MAP_CONFIG_DESTROYED"]: (state, action) => {
    state.imageMapConfigs = state.imageMapConfigs.filter((imageMapConfig) => imageMapConfig.id !== action.payload.id)
  },

  ["CABLE_IMAGE_MAP_CREATED"]: (state, action) => {
    state.imageMaps = [
      ...state.imageMaps.filter((imageMap) => imageMap.id !== action.payload.id),
      action.payload
    ]
  },
  ["CABLE_IMAGE_MAP_UPDATED"]: (state, action) => {
    state.imageMaps = [
      ...state.imageMaps.filter((imageMap) => imageMap.id !== action.payload.id),
      action.payload
    ]
  },
  ["CABLE_IMAGE_MAP_DESTROYED"]: (state, action) => {
    state.imageMaps = state.imageMaps.filter((imageMap) => imageMap.id !== action.payload.id)
  },

  ["CABLE_IMAGE_HOTSPOT_CONFIG_CREATED"]: (state, action) => {
    state.imageMapConfigs = state.imageMapConfigs.map((imageMapConfig) => {
      if (imageMapConfig.id === action.payload.image_map_config_di) {
        return {
          ...imageMapConfig,
          image_hotspot_configs: [
            ...imageMapConfig.image_hotspot_configs.filter((imageHotspotConfig) => imageHotspotConfig.id !== action.payload.id),
            action.payload
          ]
        }
      }
      return imageMapConfig
    })
  },
  ["CABLE_IMAGE_HOTSPOT_CONFIG_UPDATED"]: (state, action) => {
    state.imageMapConfigs = state.imageMapConfigs.map((imageMapConfig) => {
      if (imageMapConfig.id === action.payload.image_map_config_di) {
        return {
          ...imageMapConfig,
          image_hotspot_configs: [
            ...imageMapConfig.image_hotspot_configs.filter((imageHotspotConfig) => imageHotspotConfig.id !== action.payload.id),
            action.payload
          ]
        }
      }
      return imageMapConfig
    })
  },
  ["CABLE_IMAGE_HOTSPOT_CONFIG_DESTROYED"]: (state, action) => {
    state.imageMapConfigs = state.imageMapConfigs.map((imageMapConfig) => {
      if (imageMapConfig.id === action.payload.image_map_config_di) {
        return {
          ...imageMapConfig,
          image_hotspot_configs: imageMapConfig.image_hotspot_configs.filter((imageHotspotConfig) => imageHotspotConfig.id !== action.payload.id)
        }
      }
      return imageMapConfig
    })
  },

  ["CABLE_IMAGE_HOTSPOT_CREATED"]: (state, action) => {
    state.imageMaps = state.imageMaps.map((imageMap) => {
      if (imageMap.id === action.payload.image_map_id) {
        return {
          ...imageMap,
          image_hotspots: [
            ...imageMap.image_hotspots.filter((imageHotspot) => imageHotspot.id !== action.payload.id),
            action.payload
          ]
        }
      }
      return imageMap
    })
  },
  ["CABLE_IMAGE_HOTSPOT_UPDATED"]: (state, action) => {
    state.imageMaps = state.imageMaps.map((imageMap) => {
      if (imageMap.id === action.payload.image_map_id) {
        return {
          ...imageMap,
          image_hotspots: [
            ...imageMap.image_hotspots.filter((imageHotspot) => imageHotspot.id !== action.payload.id),
            action.payload
          ]
        }
      }
      return imageMap
    })
  },
  ["CABLE_IMAGE_HOTSPOT_DESTROYED"]: (state, action) => {
    state.imageMaps = state.imageMap.map((imageMap) => {
      if (imageMap.id === action.payload.image_map_id) {
        return {
          ...imageMap,
          image_hotspots: imageMap.image_hotspots.filter((imageHotspot) => imageHotspot.id !== action.payload.id)
        }
      }
      return imageMap
    })
  },

  ["CABLE_MEDIA_FILE_CREATED"]: (state, action) => {
    state.imageMaps = state.imageMaps.map((imageMap) => {
      return {
        ...imageMap,
        image_hotspots: imageMap.image_hotspots.map((imageHotspot) => {
          if (action.payload.attachable_id === imageHotspot.id) {
            return {
              ...imageHotspot,
              media_files: [
                ...imageHotspot.media_files.filter((media_file) => media_file.id !== action.payload.id),
                action.payload
              ],
              slideshow_images: [
                ...imageHotspot.slideshow_images.filter((media_file) => media_file.id !== action.payload.id),
                action.payload
              ]
            };
          }
          return imageHotspot
        })
      }
    })
  },
  ["CABLE_MEDIA_FILE_UPDATED"]: (state, action) => {
    state.imageMaps = state.imageMaps.map((imageMap) => {
      return {
        ...imageMap,
        image_hotspots: imageMap.image_hotspots.map((imageHotspot) => {
          if (action.payload.attachable_id === imageHotspot.id) {
            return {
              ...imageHotspot,
              media_files: [
                ...imageHotspot.media_files.filter((media_file) => media_file.id !== action.payload.id),
                action.payload
              ],
              slideshow_images: [
                ...imageHotspot.slideshow_images.filter((media_file) => media_file.id !== action.payload.id),
                action.payload
              ]
            };
          }
          return imageHotspot
        })
      }
    })
  },
  ["CABLE_MEDIA_FILE_DESTROYED"]: (state, action) => {
    state.imageMaps = state.imageMaps.map((imageMap) => {
      return {
        ...imageMap,
        image_hotspots: imageMap.image_hotspots.map((imageHotspot) => {
          if (action.payload.attachable_id === imageHotspot.id) {
            return {
              ...imageHotspot,
              media_files: imageHotspot.media_files.filter((media_file) => media_file.id !== action.payload.id),
              slideshow_images: imageHotspot.slideshow_images.filter((media_file) => media_file.id !== action.payload.id)
            };
          }
          return imageHotspot
        })
      }
    })
  }
});

export default reducer;
